export default [
    { codigo: 1, valor: 'REVOGADA', texto: 'Revogada' },
    { codigo: 2, valor: 'ANULADA', texto: 'Anulada' },
    { codigo: [4, 3], valor: 'DESERTA_FRACASSADA', texto: 'Deserto/Fracassado' },
    { codigo: 10, valor: 'SUSPENSA', texto: 'Suspensa' },
    { codigo: 11, valor: 'REVOGACAO_RETOMADA', texto: 'Revogação da suspensão ou retomada da licitação' },
    { codigo: 20, valor: 'ERRATA_REPUBLICACAO', texto: 'Publicação de errata ou republicação' },
    { codigo: 21, valor: 'CORRECAO', texto: 'Correção de homologação' }
];